export default class OperationRunner {
  constructor(operation, withPreloader = false) {
    this.operation = operation;
    this.withPreloader = withPreloader;
  }

  run() {
    const axiosPromise = this.operation.execute();
    this.enablePreloader();

    return new Promise((resolve, reject) => {
      axiosPromise
        .then((r) => { resolve(this.operation.modifyResponse(r)); })
        .catch((e) => {
          this.constructor.setError(e.response);
          reject(this.operation.modifyError(e));
        })
        .finally(() => { this.disablePreloader(); });
    });
  }

  static addPreloader() {
    throw new Error('Function is not implemented');
  }

  static removePreloader() {
    throw new Error('Function is not implemented');
  }

  static setError() {
    throw new Error('Function is not implemented');
  }

  static setStoreFunctions(addPreloader, removePreloader, setError) {
    super.addPreloader = addPreloader;
    super.removePreloader = removePreloader;
    super.setError = setError;
  }

  enablePreloader() {
    if (!this.withPreloader) return;

    this.preloaderId = this.constructor.addPreloader();
  }

  disablePreloader() {
    if (!this.preloaderId) return;

    this.constructor.removePreloader(this.preloaderId);
  }
}
